import { render, staticRenderFns } from "./Truncate.vue?vue&type=template&id=09e09e9f&scoped=true"
import script from "./Truncate.vue?vue&type=script&lang=js"
export * from "./Truncate.vue?vue&type=script&lang=js"
import style0 from "./Truncate.vue?vue&type=style&index=0&id=09e09e9f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e09e9f",
  null
  
)

export default component.exports